/**
 * vue component (push handler) >> push methods >> push service >> vuex
 */
import vuexStore from '@/vuex-store';
import { listControlActionType } from '@/vuex-store/list-control/actions';
const { state } = vuexStore;
export const fulfillmentPushService = {
    /**
     * 워커 추가
     * @param pushData
     */
    addWorker(pushData) {
        vuexStore.dispatch(listControlActionType.addWorker, pushData);
    },
    /**
     * 워커 업데이트
     * @param pushData
     * @param workerCode
     * @returns
     */
    updateWorker(pushData, workerCode) {
        if (!state.listControl.workerList[workerCode]) {
            console.log(`[updateWorker] Not exist worker. Worker id: ${workerCode}`);
            return;
        }
        const { relatedWeight } = state.listControl.workerList[workerCode];
        pushData.setRelatedWeight(relatedWeight);
        vuexStore.dispatch(listControlActionType.updateWorker, pushData);
    },
    /**
     * 워커 제거
     * @param workerCode
     */
    deleteWorker(workerCode) {
        vuexStore.dispatch(listControlActionType.deleteWorker, workerCode);
        if (state.listControl.selectedWorker?.user?.code === workerCode) {
            vuexStore.dispatch(listControlActionType.setSelectedWorker, workerCode);
        }
    },
    /**
     * 워커 퇴근
     * @param pushData
     * @param workerCode
     */
    offWorker(pushData, workerCode) {
        const { orderInfo } = pushData;
        if (!state.listControl.workerList[workerCode]) {
            console.log(`[WARN][handlePushFulfillment] Not exist worker. Worker id: ${workerCode}`);
            return;
        }
        // 주문 없으면 제거
        if (!orderInfo.length) {
            this.deleteWorker(workerCode);
            return;
        }
        // 주문 있으면 퇴근 표시
        vuexStore.dispatch(listControlActionType.onOffWorker, {
            code: workerCode,
            flag: false,
        });
    },
    /**
     * 배차 취소된 라이더 주문 제거
     * @param {Array} orderIds fulfillment 주문 데이터
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clearWorkerOrderMarkers(orderIds = []) {
        //   orderIds.forEach((orderId) => {
        //     const mkDrop = HubControlMap.getInstance()!.mapMarkerList.drops.getMarker(orderId);
        //     if (!mkDrop) {
        //       console.log('[_clearWorkerOrderMarkers]', orderId);
        //       return;
        //     }
        //     mkDrop.decreaseDropMarkerWeight();
        //   });
    },
};
